import { Info, MonitorHeart, Troubleshoot } from "@mui/icons-material";

export const tabs = [
    {
        icon: <Troubleshoot />,
        entity: "eeg_analysis",
        label: "Análise de EEG",
        isDetail: false,
    },
    {
        icon: <Info />,
        entity: "detail",
        label: "Detalhes",
        isDetail: true,
    },

    {
        icon: <MonitorHeart />,
        entity: "eeg_data",
        label: "Dados de EEG",
        isDetail: false,
    },
];
